<template>
	<div>
		<div class="list_top_box">
			<h3>Sales by Item Group</h3>
			<p class="mgb_5">
				<span>Period Type: </span>
				<label class="mgr_10"><input type="radio" v-model="computedPeriod" value="LastWeek" /> LastWeek</label>
				<label class="mgr_10"><input type="radio" v-model="computedPeriod" value="LastMonth" /> LastMonth</label>
				<label class="mgr_10"><input type="radio" v-model="computedPeriod" value="Custom" />Custom</label>

				<span>
					<CustomDatePicker :disabled="period !== 'Custom'" v-model.trim="from_date" /> ~
					<CustomDatePicker :disabled="period !== 'Custom'" v-model.trim="to_date" />
				</span>
			</p>

			<p>
				<span>Sales Team:</span>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="sales_team_list" v-model="sales_team_code" @set-code="sales_team = $event"/></span>
				<span>Based on: </span>
				<select class="tbl_select sm_int mgr_5" v-model="sort_key">
					<option value="quantity">Quantity</option>
					<option value="amount">Amount</option>
				</select>

				<a href="javascript:;" class="search_bt" @click="search(0)">Search</a>
			</p>
		</div>
		<div style="overflow: hidden; min-height: 320px; max-height: 320px; position: relative;">
			<b style="position: absolute; top: 5px; right: 20px;">Currency: $</b>
			<ItemClassGroupGraph style="margin: 10px 0;" :from_date="search_from_date" :to_date="search_to_date" :sort_key="search_sort_key" :sales_team="sales_team_code" :key="chart_key" @emitSumData="sum_data = $event" />
		</div>
		<div class="bottom_bt_box">
			<div class="col_6">
				<p>Search Period: {{ search_from_date }} ~ {{ search_to_date }}</p>
				<p>Search Based on: {{ search_sort_key.toUpperCase() }}</p>
				<p v-if="search_sales_team">Searched Sales Team: {{ search_sales_team }}</p>
			</div>
			<div class="col_6">
				<b class="mgr_10" v-for="(prop, index) in Object.keys(sum_data)" :key="index">{{ prop }}: {{ sum_data[prop] | commaSeparated }}</b>
			</div>
		</div>
	</div>
</template>

<script>
import ItemClassGroupGraph from '@/views/statistics/itemClassGroup/ItemClassGroupGraph';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect.vue';
import { toText } from '@/utils/date';
import { apiIndex } from '@/api/basicinfo/salesteam';
export default {
	data: function() {
		return {
			sort_key: null,
			period: null,
			from_date: null,
			to_date: null,
			sales_team: null,
			sales_team_code: null, // CodeSelect에 선택한 Sales Team의 description을 나오게 하려면 v-model속성을 사용하여야 함.

			chart_key: 0,

			search_from_date: null,
			search_to_date: null,
			search_sort_key: null,
			search_sales_team: null,

			sum_data: {},
			sales_team_list: [],
		};
	},
	components: {
		ItemClassGroupGraph,
		CustomDatePicker,
		CodeSelect,
	},
	computed: {
		computedPeriod: {
			get: function() {
				return this.period;
			},
			set: function(newValue) {
				this.period = newValue;
				this.changeFromNToDate();
			},
		},
	},
	methods: {
		changeFromNToDate() {
			if (this.period === 'Custom') return;

			let today = new Date();
			let from_date = null;
			let to_date = null;

			if (this.period === 'LastWeek') {
				to_date = new Date(today.getFullYear(), today.getMonth(), today.getDate() - (today.getDay() + 1));
				from_date = new Date(to_date.getFullYear(), to_date.getMonth(), to_date.getDate() - 6);
			} else if (this.period === 'LastMonth') {
				to_date = new Date(today.getFullYear(), today.getMonth(), 0);
				from_date = new Date(today.getFullYear(), today.getMonth() - 1, 1);
			}

			this.from_date = toText(from_date, '-');
			this.to_date = toText(to_date, '-');
		},
		search() {
			this.search_from_date = this.from_date;
			this.search_to_date = this.to_date;
			this.search_sort_key = this.sort_key;
			this.search_sales_team = this.sales_team ? this.sales_team.name : null;

			this.chart_key++;
		},
		async index() {
			let { data } = await apiIndex();
			this.sales_team_list = data.salesteamList;
		},
		async init() {
			this.sort_key = 'quantity';
			this.computedPeriod = 'LastWeek';

			await this.search(0);
			await this.index();
		},
	},
	created() {
		this.init();
	},
};
</script>

<style></style>
